import "./index.css";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdSurplusTransportTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdSurplusTransportContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_MATERIALS_TRANSPORT")}
        subDescription={t("SURPLUS_MATERIALS_TRANSPORT_DESC")}
        isNormal={true}
        number={"31.4"}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-surplus-transport-lca-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdSurplusTransportTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdSurplusTransportContents;
